import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { IAdminEmailView, IRoleEdit } from 'app/models/admin/admin';
import { IComplaintSearchViewModel } from 'app/models/search/search';
import { IReportSelectItems, ISelectItems } from 'app/models/shared/shared';
import { AdminService } from 'app/services/admin/admin.service';
import { ReportsService } from 'app/services/reports/reports.service';

@Component({
  selector: 'app-admin-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss']
})

export class RolesComponent implements OnInit {

  list: IRoleEdit[] = [];
  showRole: boolean = false;
  role: string = '';
  editingRole: string = '';
  currentRole: IRoleEdit = null;
  createRoleFlag: boolean = false;

  displayedColumns: string[] = ['name', 'action'];

  dataSource = new MatTableDataSource<IRoleEdit>(this.list);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  // form = new UntypedFormGroup({
  //   countyId: new UntypedFormControl(''),
  //   emailTypeDescription: new UntypedFormControl(''),
  //   emailTo: new UntypedFormControl(''),
  //   emailCc: new UntypedFormControl('')
  // });

  constructor(public adminService: AdminService,
    public sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.getRoles();
  }

  getRoles() {
    this.adminService.getRoles().subscribe({
      next: response => {
        this.list = response;
        this.dataSource.data = this.list;
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.showRole = false;
        this.createRoleFlag = false;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Role Data");
      },
    });
  }

  createRole() {
    this.showRole = true;
    this.createRoleFlag = true;
    this.editingRole = '';
  }

  editRole(role: IRoleEdit) {
    this.showRole = true;
    this.editingRole = role.name;
    this.currentRole = role;
  }

  saveRole() {
    if (this.editingRole != null && this.editingRole != '') {
      if (this.createRoleFlag) {
        this.adminService.createRole(this.editingRole).subscribe({
          next: response => {
            this.sharedService.toastr.success("Saved Role Data");
            this.getRoles();
            this.showRole = false;
            this.createRoleFlag = false;
          },
          error: e => {
            this.sharedService.toastr.error("Could not get Role Data");
          },
        });
      }
      else {
        this.adminService.saveRole(this.currentRole.id, this.editingRole).subscribe({
          next: response => {
            this.sharedService.toastr.success("Saved Role Data");
            this.getRoles();
            this.showRole = false;
          },
          error: e => {
            this.sharedService.toastr.error("Could not get Role Data");
          },
        });
      }
    }
  }

  deleteRole(role: IRoleEdit) {
    this.sharedService.openConfirm(
      'Are you sure you want to delete this Role?'
    );
    this.sharedService.confirmed().subscribe(
      confirmed => {
        if (confirmed) {
          this.adminService.deleteRole(role.id, role.name).subscribe({
            next: response => {
              this.sharedService.toastr.success("Deleted Role Data");
              this.getRoles();
              this.showRole = false;
            },
            error: e => {
              this.sharedService.toastr.error("Could not get Role Data");
            },
          });
        }
      }
    );
  }

  cancel() {
    this.showRole = false;
  }

}


